module.exports = __webpack_public_path__ + "img/cns_printer_mac11.c689c735.png";